import React from "react";

import {Card, Divider, Typography} from "antd";
import {getPurOrg} from "../../../utils";
import {startPaiement} from "../../../services/paiementLauncher";


const {Text,Title}=Typography


export default class ServicesRender extends React.Component{

    state={
        returnUrl:""
    }

    isFloat(n){
      return Number(n) === n && n % 1 !== 0;
    }

    componentDidMount() {
        // window.location, JAMAIS window.top.location : en iframe d'une autre
        // origine, la simple LECTURE de l'URL du top lève une SecurityError, et
        // l'exception au montage faisait tomber la page sur l'écran d'erreur —
        // précisément dans le mode intégré que ces pages doivent servir.
        // C'est déjà l'URL de la page courante que le tunnel de paiement
        // attend en returnUrl (cf. services/paiementLauncher.buildReturnUrl).
        this.setState({returnUrl:window.location.href})
    }

    getServiceByGroupe()
    {
      const {org}=this.props.context

      const selectedOrg=org

      var groupedServices=[]

      selectedOrg.services.filter((s)=>s.recurrent==false)
      .forEach(item => {
          var groupedIndex=groupedServices.findIndex(gs=>gs.groupe.id==item.groupe.id)

          if(groupedIndex==-1){
            groupedServices.push({
              groupe:item.groupe,
              items:[]
            })

            groupedIndex=groupedServices.length-1
          }

          groupedServices[groupedIndex].items.push(item)
      });

      return groupedServices
    }


    renderServices(item,index)
    {
        const {org}=this.props.context

        const selectedOrg=org

        // Ancre (et non div) : la carte reste atteignable au clavier, annonçable
        // par un lecteur d'écran, ouvrable en nouvel onglet — le href sert de
        // repli, le clic passe par le lanceur qui sait sortir de l'iframe.
        // Payload brut ; startPaiement pose le sessionStorage (source APP/WEB +
        // returnUrl) ET navigue — y compris en sortant de l'iframe quand le site
        // est intégré, ce qu'un <Link> ne saurait pas faire : son href est figé au
        // rendu, sans la config que la sortie doit emporter dans l'URL.
        // Cf. services/paiementLauncher.
        const object={organisation:getPurOrg(selectedOrg),type:"SERVICE",typeId:item.id,cerfa:item.cerfa,service:item}

      return(
          <a
              href={selectedOrg.BASE_WEB_URL+"/paiement"}
              onClick={(e)=>{e.preventDefault();startPaiement(object,{org:selectedOrg})}}
              style={{display:"block",cursor:"pointer",color:"inherit",textDecoration:"none"}}
          >
            <Card
                key={index}
                style={{boxShadow:"rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",display:'flex',flexDirection:"column",borderRadius:15,justifyContent:"center",alignItems:"center",backgroundColor:"#FFF"}}>

                <div style={{display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center"}}>
                    <Text style={{maxHeight:20,fontFamily:"Poppins",fontWeight:'500',color:"#000",fontSize:15,overflow:"hidden",textOverflow:"ellipsis",textAlign:"center"}}>{item.name}</Text>
                    <Text style={{fontWeight:'400',color:"grey",fontSize:12,marginTop:5}}>{this.isFloat(item.montant)?parseFloat(item.montant).toFixed(2):item.montant}€</Text>
                </div>

            </Card>
          </a>
      )
    }

    render()
    {
      const context=this.props.context

      const services=this.getServiceByGroupe()


      return(
        <div style={{display:"flex",alignItems:"center",justifyContent:"center",flexDirection:"column"}}>

              {services.length==0 && (
                <div style={{display:'flex',flexDirection:"column",flex:1,height:500,justifyContent:"center",alignItems:"center"}}>
                  <Text style={{textAlign:"center",color:"grey"}}>Désolé...</Text>
                  <Text style={{textAlign:"center",color:"grey",marginTop:5}}>Cet organisme n'a pas encore créé d'activité.</Text>
                </div>
              )}

              {services.map((item,index)=>{

                return(
                  <div key={index} style={{marginTop:10,marginBottom:30,border:"0px solid red",width:"100%"}}>

                    <div style={{display:'flex',flexDirection:"column",alignItems:context.isMobile?"center":"flex-start",textAlign:context.isMobile?"center":"left",marginBottom:50}}>
                      <h3 style={{maxWidth:"100%",color:"#000",fontWeight:"600",flexDirection:"row"}}>{item.groupe.name}</h3>
                      <div style={{marginLeft:0,width:150,borderTop:"5px solid #D65DB1",marginTop:5,borderRadius:20}}/>
                    </div>

                    <div style={{display:'flex',width:"100%",flexDirection:"row",gap:20,alignItems:"center",border:"0px solid black",flexWrap:"wrap"}}>
                      {item.items.map((item2,index2)=>this.renderServices(item2,index2))}
                    </div>
                      <Divider/>
                  </div>
                )
              })}

        </div>
      )
    }
  }
